import { Button } from '@monorepo/nova-ui';
import { styled } from '@mui/material/styles';

export const StyledFooterLinkButton = styled(Button)(() => ({
  justifyContent: 'flex-start',
  minHeight: 'unset !important',
  padding: '0 !important',
  textAlign: 'left',
  textDecoration: 'none',
  whiteSpace: 'normal !important',
  overflow: 'visible !important',
  width: '100%',
  '&:hover': {
    textDecoration: 'none',
  },
}));
